module.exports = __webpack_public_path__ + "img/BUTTON.c3937fc9.svg";